module.exports = __webpack_public_path__ + "img/app-store.0326328a.png";